<template>
  <div>
    <div class="w-full flex justify-center items-end">
      <button
        v-for="tab in items"
        :key="tab.id"
        :class="{ active: tab.blnActive }"
        class="tabs-footer w-1/2 md:w-auto md:mx-2 rounded-t-lg py-2 px-4"
        @click="selectTab(tab)"
        type="button"
      >
        <span class="mx-4">{{ tab.title }}</span>
      </button>
    </div>

    <div
      :class="{ active: items[0].blnActive }"
      class="tabs-content px-4 py-8 bg-black text-white"
    >
      <div
        class="container flex flex-col justify-center items-center px-0 mx-auto"
      >
        <div>
          <p class="px-3 lg:px-0 py-2 text-center font-semibold">
            Servicio al cliente / Ventas
          </p>

          <p class="my-2 p-3 lg:p-0 text-center">
            Lunes a Viernes de 7:00 AM a 12:00 AM / Sábado y Domingo de 7:00 AM
            a 10:00 PM. Hora Local.
          </p>
        </div>

        <div class="lg:w-1/4 pr-0 lg:p-2 text-center">
          <p class="font-semibold py-2">
            {{ social.title }}
          </p>

          <div class="flex justify-around items-center">
            <a
              class="px-3 py-1"
              :title="link.icon"
              :href="link.href"
              v-for="link in social.links"
              :key="link.icon"
            >
              <font-awesome-icon size="2x" :icon="['fab', link.icon]" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div
      :class="{ active: items[1].blnActive }"
      class="tabs-content px-4 py-8 bg-black text-white"
    >
      <div class="container flex md:flex-row flex-col mx-auto flex-wrap">
        <div
          v-for="menu in sitemap"
          :key="menu.title"
          class="lg:flex-1 lg:w-auto w-1/2 p-2"
        >
          <p class="pb-6 font-semibold border-b border-white">
            {{ menu.title }}
          </p>

          <ul class="pt-4">
            <li
              v-for="link in menu.links"
              :key="link.text"
              class="
                block
                py-2
                text-sm text-decoration-none text-white
                hover:text-pastel-green hover:underline
              "
            >
              <a :href="link.href">{{ link.text }}</a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      items: [
        {
          id: 1,

          title: "Contáctanos",

          text: "",

          blnActive: true,
        },

        {
          id: 2,

          title: "Descubre",

          text: "",

          blnActive: false,
        },
      ],

      social: {
        title: "Redes sociales",

        links: [
          {
            href: "https://www.facebook.com/XcaretPark",

            icon: "facebook-f",
          },

          {
            href: "https://twitter.com/XcaretPark",

            icon: "twitter",
          },

          {
            href: "https://www.instagram.com/xcaretpark/",

            icon: "instagram",
          },

          {
            href: "https://www.youtube.com/user/XcaretPark",

            icon: "youtube",
          },
        ],
      },

      sitemap: [
        {
          title: "Destino",

          links: [
            {
              text: "Qué hacer en vacaciones",

              href: "https://www.xcaret.com/es/tours-en-cancun-y-riviera-maya/",
            },

            {
              text: "Cancún",

              href: "https://www.xcaret.com/es/que-hacer-en-cancun/",
            },

            {
              text: "Isla Mujeres",

              href: "https://www.xcaret.com/es/que-hacer-en-isla-mujeres/",
            },

            {
              text: "Playa del Carmen",

              href: "https://www.xcaret.com/es/que-hacer-en-playa-del-carmen/",
            },

            {
              text: "Riviera Maya",

              href: "https://www.xcaret.com/es/que-hacer-en-riviera-maya/",
            },

            {
              text: "Cozumel",

              href: "https://www.xcaret.com/es/que-hacer-en-cozumel/",
            },

            {
              text: "Tulum",

              href: "https://www.xcaret.com/es/que-hacer-en-tulum/",
            },

            {
              text: "Quintana Roo",

              href: "https://www.xcaret.com/es/conoce-quintana-roo/",
            },

            {
              text: "México",

              href: "https://www.xcaret.com/es/que-hacer-en-mexico/",
            },
          ],
        },

        {
          title: "Parques y Tours",

          links: [
            {
              text: "Acerca de Xcaret",

              href: "/es/acerca-de-xcaret/",
            },

            {
              text: "Acerca de Xel-Há",

              href: "/es/parques-y-tours/acerca-de-xelha/",
            },

            {
              text: "Acerca de Xplor",

              href: "/es/parques-y-tours/acerca-de-xplor/",
            },

            {
              text: "Acerca de Xplor Fuego",

              href: "/es/parques-y-tours/acerca-de-xplor-fuego/",
            },

            {
              text: "Acerca de Xavage",

              href: "/es/parques-y-tours/acerca-de-xavage/",
            },

            {
              text: "Acerca de Xoxi",

              href: "/es/parques-y-tours/acerca-de-xoximilco/",
            },

            {
              text: "Acerca de Xenses",

              href: "/es/parques-y-tours/acerca-de-xenses/",
            },

            {
              text: "Acerca de Xenotes",

              href: "/es/parques-y-tours/acerca-de-xenotes/",
            },

            {
              text: "Acerca de Xichen",

              href: "/es/parques-y-tours/acerca-de-xichen/",
            },
          ],
        },

        {
          title: "Comprar",

          links: [
            {
              text: "Comprar Xcaret",

              href: "/es/comprar-mi-entrada/",
            },

            {
              text: "Comprar Xel-Há",

              href: "/es/comprar-mi-entrada-xel-ha/",
            },

            {
              text: "Comprar Xplor",

              href: "/es/parques-y-tours/entrada-xplor/",
            },

            {
              text: "Comprar Xplor Fuego",

              href: "/es/parques-y-tours/entrada-xplor-fuego/",
            },

            {
              text: "Comprar Xavage",

              href: "/es/parques-y-tours/entrada-xavage/",
            },

            {
              text: "Comprar Xoxi",

              href: "/es/parques-y-tours/entrada-xoximilco/",
            },

            {
              text: "Comprar Xenses",

              href: "/es/parques-y-tours/entrada-xenses/",
            },

            {
              text: "Comprar Xenotes",

              href: "/es/parques-y-tours/tour-xenotes/",
            },

            {
              text: "Comprar Xichén",

              href: "/es/parques-y-tours/tour-xichen-deluxe/",
            },
          ],
        },

        {
          title: "Acerca de Xcaret",

          links: [
            {
              text: "Mapa de sitio",

              href: "/es/mapa-de-sitio/",
            },

            {
              text: "Blog Xcaret",

              href: "https://blog.xcaret.com/es/",
            },

            {
              text: "Cómo llegar",

              href: "/es/como-llegar-a-xcaret/",
            },

            {
              text: "Atracciones en Xcaret",

              href: "/es/atracciones-xcaret/",
            },

            {
              text: "Membresía soy Xcaret",

              href: "https://www.soyxcaret.com/",
            },

            {
              text: "Promociones",

              href: "/es/promociones/",
            },

            {
              text: "¿Ya nos visitaste?",

              href: "https://www.tuexperiencia.travel/ya-visite/xcaret.php",
            },

            {
              text: "¿Aún no nos visitas?",

              href: "https://www.tuexperiencia.travel/proximo-a-visitar/xcaret.php",
            },

            {
              text: "Responsabilidad Social",

              href: "https://www.grupoxcaret.com/es/sostenibilidad-corporativa/",
            },
          ],
        },

        {
          title: "Otros",

          links: [
            {
              text: "Acerca de Grupo Xcaret",

              href: "https://www.grupoxcaret.com/es/acerca-de-grupo-xcaret/",
            },

            {
              text: "Contáctanos",

              href: "https://www.xcaretexperiencias.com/contacto-xcaretexperiencias.php",
            },

            {
              text: "Módulos Xcaret",

              href: "/es/modulos-xcaret/",
            },

            {
              text: "Afiliados",

              href: "https://www.xcaretexperiencias.com/afiliados.php",
            },

            {
              text: "Agencias Online",

              href: "https://www.aolxcaret.com/",
            },

            {
              text: "Bodas",

              href: "https://www.bodasxcaret.com/",
            },

            {
              text: "Meetings & Events",

              href: "https://www.xcaretgrupos.com/",
            },

            {
              text: "Sala de Prensa",

              href: "https://www.grupoxcaret.com/es/seccion/sala-de-prensa/",
            },
          ],
        },
      ],
    };
  },

  methods: {
    selectTab(selected) {
      this.items.forEach(function (item) {
        selected.id == item.id
          ? (item.blnActive = true)
          : (item.blnActive = false);
      });
    },
  },
};
</script>


<style lang="scss">
@import "../../css/variables.scss";

.tabs-footer {
  background-color: $yellow-photo;

  color: #222;

  &.active {
    color: #fff;

    background-color: #383838;
  }
}

.tabs-content {
  display: none;

  &.active {
    display: block;
  }
}
</style>